<h2 mat-dialog-title>
	<mat-icon style="margin-right: 8px" aria-hidden="true">domain_add</mat-icon
	>{{ 'sponsor.person_create.dialog.title' | transloco }}
</h2>
<mat-dialog-content>
	<form [formGroup]="form" class="dialog-window">
		<div>
			<p lvrPadding [padVertical]="8">{{ 'sponsor.person_create.dialog.hint1' | transloco }}</p>
			<mat-form-field lvrInput [class]="showWarning() ? 'lvr-warning' : ''">
				<input
					matInput
					formControlName="person"
					[placeholder]="'sponsor.person_create.dialog.placeholder' | transloco"
					[matAutocomplete]="auto"
				/>
				<mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption [displayWith]="displayName">
					@if (form.get('person')?.value && suggestions().length === 0) {
						<mat-option disabled>
							{{ 'sponsor.person_create.dialog.no_suggestion' | transloco }}
						</mat-option>
					} @else {
						@for (person of suggestions(); track person.id) {
							<mat-option [value]="person">
								<span> {{ person.firstName }} {{ person.lastName }} </span>
								<br />
								<span class="text-sm">
									{{ person.dateOfBirth | date: 'dd.MM.yyyy' }}
								</span>
							</mat-option>
						}
					}
				</mat-autocomplete>
				@if (showWarning()) {
					<mat-hint class="lvr-warning">{{ 'sponsor.person_create.dialog.suggestion_found' | transloco }}</mat-hint>
				}
			</mat-form-field>
		</div>
		<mat-dialog-actions class="actions-row">
			<lvr-button
				variant="secondary"
				[label]="'base.button.cancel' | transloco"
				[type]="'button'"
				icon="disabled_by_default"
				mat-dialog-close
			>
			</lvr-button>
			<lvr-button
				variant="primary"
				[label]="btnText() | transloco"
				[type]="'button'"
				[disabled]="form.invalid"
				(clicked)="done()"
				icon="add"
			>
			</lvr-button>
		</mat-dialog-actions>
	</form>
</mat-dialog-content>
